import type { ReactNode } from 'react';

export interface Crumb {
  /** Crumb text. Optional when `icon` is used instead (e.g. the home crumb). */
  label?: ReactNode;
  href?: string;
  /** Phosphor icon class, e.g. "ph-house" (used for the first/home crumb). */
  icon?: string;
}

export interface BreadcrumbProps {
  items: Crumb[];
  className?: string;
}

/** Limitless breadcrumb. The last item renders as the active (non-link) crumb. */
export function Breadcrumb({ items, className = 'py-2' }: BreadcrumbProps) {
  return (
    <div className={`breadcrumb ${className}`.trim()}>
      {items.map((c, i) => {
        const last = i === items.length - 1;
        const content = c.icon ? <i className={c.icon} /> : c.label;
        if (last) {
          return (
            <span key={i} className="breadcrumb-item active">
              {content}
            </span>
          );
        }
        return (
          <a key={i} href={c.href ?? '#'} className="breadcrumb-item">
            {content}
          </a>
        );
      })}
    </div>
  );
}
